import React from 'react'
import PropTypes from 'prop-types'

const BeaconIcon = (props) => {
  const { color = '#ffffff', classes = 'w-20' } = props

  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5563 28C11.2283 28 10.9534 27.8917 10.7315 27.675C10.5096 27.4583 10.3987 27.1899 10.3987 26.8696V13.3043C10.3987 12.9841 10.5096 12.7156 10.7315 12.4989C10.9534 12.2822 11.2283 12.1739 11.5563 12.1739H18.5016C18.8296 12.1739 19.1045 12.2822 19.3264 12.4989C19.5482 12.7156 19.6592 12.9841 19.6592 13.3043V26.8696C19.6592 27.1899 19.5482 27.4583 19.3264 27.675C19.1045 27.8917 18.8296 28 18.5016 28H11.5563ZM15.0289 18.1087C15.4341 18.1087 15.7765 17.9721 16.0563 17.6989C16.336 17.4257 16.4759 17.0913 16.4759 16.6957C16.4759 16.3 16.336 15.9656 16.0563 15.6924C15.7765 15.4192 15.4341 15.2826 15.0289 15.2826C14.6238 15.2826 14.2814 15.4192 14.0016 15.6924C13.7219 15.9656 13.582 16.3 13.582 16.6957C13.582 17.0913 13.7219 17.4257 14.0016 17.6989C14.2814 17.9721 14.6238 18.1087 15.0289 18.1087ZM10.9196 10.4217L9.29904 8.83913C10.0707 8.08551 10.9486 7.51087 11.9325 7.11522C12.9164 6.71956 13.9486 6.52174 15.0289 6.52174C16.1093 6.52174 17.1415 6.71956 18.1254 7.11522C19.1093 7.51087 19.9871 8.08551 20.7588 8.83913L19.1383 10.4217C18.5788 9.87536 17.9469 9.46558 17.2428 9.19239C16.5386 8.9192 15.8006 8.78261 15.0289 8.78261C14.2572 8.78261 13.5193 8.9192 12.8151 9.19239C12.1109 9.46558 11.4791 9.87536 10.9196 10.4217ZM7.67846 7.25652L6 5.61739C7.21543 4.46812 8.59968 3.5779 10.1527 2.94674C11.7058 2.31558 13.3312 2 15.0289 2C16.7267 2 18.3521 2.31558 19.9051 2.94674C21.4582 3.5779 22.8232 4.48696 24 5.67391L22.3794 7.25652C21.4148 6.27681 20.2958 5.53261 19.0225 5.02391C17.7492 4.51522 16.418 4.26087 15.0289 4.26087C13.6399 4.26087 12.3087 4.51522 11.0354 5.02391C9.76206 5.53261 8.64309 6.27681 7.67846 7.25652ZM12.7138 25.7391H17.3441V14.4348H12.7138V25.7391Z"
        fill={color}
      />
    </svg>
  )
}

BeaconIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(BeaconIcon)
